import {createAsyncThunk} from "@reduxjs/toolkit";

import {courseService as assessmentAdministrationService} from "../services/courseService";
import type ChapterSettingsOverride from "./ChapterSettingsOverride";
import {keyProvider} from "../keyProvider";

const fetchChapterSettingsOverride = createAsyncThunk<
	{
		chapterKey: string;
		override: ChapterSettingsOverride;
	},
	{studentId: number; courseId: number; chapterId: number}
>(
	"chapterSettingsOverrides/fetch",
	async ({studentId, courseId, chapterId}) => {
		const override = await assessmentAdministrationService.getTestSettingsOverride(
			studentId,
			courseId,
			chapterId
		);

		return {
			chapterKey: keyProvider.chapter(chapterId),
			override: override,
		};
	}
);

export default fetchChapterSettingsOverride;
